import StepLayoutRoot from './step-layout.root'
import StepLayoutOneColumn from './step-layout.one-column'

export default function StepLayout() {
  return null
}

StepLayout.Root = StepLayoutRoot
StepLayout.OneColumn = StepLayoutOneColumn
